// Utilidades para persistir borradores de corta duración (carrito del POS y
// formulario de producto nuevo) usando localStorage. Los datos son pequeños y
// no contienen información sensible.

export function loadDraft<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function saveDraft(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Ignorar errores de almacenamiento (cuota llena, modo privado, etc.)
  }
}

export function clearDraft(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignorar
  }
}